import React from "react";

import { useTranslation } from "react-i18next";
import { HiOutlineClipboardCheck } from "react-icons/hi";

import { ChecklistColumn, TooltipStyle } from "./styles";

type Props = {
  value: string;
};

const CheckItemJobNumberME = (props: Props) => {
  const { value } = props;

  const { t: translate } = useTranslation();

  return (
    <ChecklistColumn>
      <span>{value}</span>
      <TooltipStyle placement="top" title={translate("meChecklistDone")}>
        <div>
          <HiOutlineClipboardCheck size={14} color="#12B76A" />
        </div>
      </TooltipStyle>
    </ChecklistColumn>
  );
};

export default CheckItemJobNumberME;
